import React from "react";

function addLineBreak (string) {
  return string.split("\n").map((subString, index) => {
      return (
        <React.Fragment key={index}>
          {subString}
          <br />
        </React.Fragment>
      )})
};

export {
  addLineBreak
}